import { render, staticRenderFns } from "./describeCard.vue?vue&type=template&id=b96dc9d8"
import script from "./describeCard.vue?vue&type=script&lang=js"
export * from "./describeCard.vue?vue&type=script&lang=js"
import style0 from "./describeCard.vue?vue&type=style&index=0&id=b96dc9d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports